module.exports = __webpack_public_path__ + "static/media/sensable_80.81553631.png";